import React from 'react';

import styles from './SignInFinished.module.css'
import {mascotOne} from "../../../../../assets/icons/icons.ts";

interface Props {

}

export const SignInFinished: React.FC<Props> = () => {
    return (
        <div className={styles.wrapper}>
            <h4 className={styles.title}>Добро пожаловать!</h4>
            <div className={styles.main}>
                <div>Благодарим за регистрацию</div>
                <img className={styles.logo} src={mascotOne}  alt='Иконка подзамену'/>
            </div>
        </div>
    );
};